/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */
import React from 'external/react';
import ReactDOM from 'external/react-dom';
import PropTypes from 'external/prop-types';
import { Button } from 'external/react-bootstrap';
import ErrorBoundary from './ErrorBoundary';

import { AppContext } from '../app-context';
import ConfigActions from '../actions/ConfigActions';
import FormActions from '../actions/FormActions';

import { getConfigStore } from '../stores/StoreFactory';
import { parsePortletConfig } from '../utils/portlet-config-util';

const ConfigStore = getConfigStore(AppContext);

function closest(el, fn) {
    return el && (
        fn(el) ? el : closest(el.parentNode, fn)
    );
}

class PortletComponent extends React.Component {

    constructor(props) {
        super(props);
        this.uid = props.portletId;
        this.portletId = props.portletId;
        this.plid = props.plid;
        this.hasConfig = props.hasConfig;
        this.ConfigForm = (props) => this.renderConfigForm(props);
        this.configFormId = this.withCtx('ConfigForm');
        this.state = this.getStateFromStores(props);
    }

    getChildContext() {
        return { contextId: '' + this.portletId };
    }

    componentDidMount() {
        const { scopeGroupId, plid, portletId, initialConfig, hasConfig } = this.props;
        if (hasConfig) {
            this.removeListener = ConfigStore.addListener(this.onChange.bind(this));
            if (initialConfig) {
                //ConfigActions.updateConfig(scopeGroupId, plid, portletId, initialConfig, this._asyncOpt());
                const prevConfig = ConfigStore.getConfig(scopeGroupId, plid, portletId) || {};
                ConfigActions.setConfig(scopeGroupId, plid, portletId, initialConfig, (initialConfig) => this.configWillChange(prevConfig, initialConfig));
            } else {
                ConfigActions.loadConfig(scopeGroupId, plid, portletId, this._asyncOpt());
            }
        }

        let widgetParentNode = ReactDOM.findDOMNode(this);
        if (!widgetParentNode) {
            widgetParentNode = document.getElementById('widget-container_' + portletId);
        }
        this.portletContainer = closest(widgetParentNode, function (el) {
            return el.className && el.className.indexOf('portlet-container') >= 0;
        });

        if (this.portletContainer != null) {
            this.setState({ portletContainerRender: true }); //Need to setState for re-rendering. state.portletContainer is used in render!
        }
    }

    componentWillUnmount() {
        if (this.removeListener) {
            this.removeListener.remove();
        }
    }

    onChange() {
        this.setState(this.getStateFromStores(this.props));
    }

    onEditConfigClick() {
        FormActions.startEditFormItem(this.configFormId, this.state.config);
    }

    onConfigActionSuccess(action) {
        const { scopeGroupId, plid, portletId } = this.props,
            config = action.payload;

        if (this.isConfigurationNeeded(config)) {
            console.warn('Load invalid configuration: ', config);
        }
        this.configWillChange(ConfigStore.getConfig(scopeGroupId, plid, portletId), config);
    }

    onFormSubmit(config) {
        ConfigActions.updateConfig(this.props.scopeGroupId, this.props.plid, this.props.portletId, config, this._asyncOpt(this.configFormId));
    }

    getStateFromStores(props) {
        const config = ConfigStore.getConfig(props.scopeGroupId, props.plid, props.portletId);
        if (props && props.initialConfig) {
            const newConfig = parsePortletConfig({
                ...props.initialConfig,
                ...config
            });
            return { config: newConfig };
        } else {
            return {
                config
            };
        }
    }

    withCtx(s) {
        return this.portletId + '.' + s;
    }

    configWillChange(prevConfig, nextConfig) {
        console.warn('Implement configWillChange(prevConfig, nextConfig)', prevConfig, nextConfig);
    }

    _asyncOpt(formId) {
        return {
            beforeSuccess: this.onConfigActionSuccess.bind(this),
            meta: {
                formId,
                closeForm: true
            }
        };
    }

    isConfigurationNeeded(config) {
        return false;
    }

    render() {
        const { config } = this.state,
            configurationNeeded = this.isConfigurationNeeded(config);

        if (configurationNeeded && !config) {
            return <p className="bg-warning">Konfiguration konnte nicht geladen werden</p>;
        }

        const classList = this.portletContainer && this.portletContainer.classList;

        let showConfigPermission = false;
        if (classList && classList.length > 0) {
            for (let i in classList) {
                if (!showConfigPermission) {
                    showConfigPermission = classList[ i ] === 'show-config';
                }
            }
        }

        if (localStorage.dev) {
            return 'Hier kommt später Inhalt';
        }

        return (
            <ErrorBoundary>


                { !configurationNeeded &&
                    this.renderPortlet(config)
                }

                { this.hasConfig && showConfigPermission && configurationNeeded &&
                    <Button variant="primary" title={ 'Konfigurieren' }
                            onClick={ this.onEditConfigClick.bind(this) }>Konfigurieren</Button>
                }

                { this.hasConfig && !showConfigPermission && configurationNeeded &&
                    <p>Sie haben nicht das Recht das Widget zu konfigurieren!</p>
                }

                { this.hasConfig && showConfigPermission &&
                    <Button variant="primary" className="configOpener" title={ 'Konfigurieren' }
                            onClick={ this.onEditConfigClick.bind(this) }>
                        <span className="icon-fliwas-gear"/>
                    </Button>
                }

                { this.hasConfig &&
                    <this.ConfigForm formId={ this.configFormId } onFormSubmit={ this.onFormSubmit.bind(this) }/>
                }
            </ErrorBoundary>);
    }

}

PortletComponent.propTypes = {
    hasConfig: PropTypes.bool.isRequired,

    scopeGroupId: PropTypes.number,
    plid: PropTypes.number,
    portletId: PropTypes.string,

    initialConfig: PropTypes.object,
    formClassName: PropTypes.string
};

PortletComponent.childContextTypes = {
    contextId: PropTypes.string
};

export default PortletComponent;





// WEBPACK FOOTER //
// ./js/components/PortletComponent.jsx